import { FC } from 'react';

import { CustomerInfoModel } from '../../../models/customer.model';
import { formatCurrency } from '../../../utils/format-currency';
import { MessageCard } from '../../message-card/message-card';
import { Flex, Text } from '@servicetitan/anvil2';

interface CustomerMetricsProps {
    data: CustomerInfoModel;
    className?: string;
}

export const CustomerMetrics: FC<CustomerMetricsProps> = ({ data, className }) => {
    return (
        <MessageCard flexDirection="column" className={className}>
            <Text variant="headline" el="h3" size="small">
                Customer Metrics
            </Text>

            <Flex gap="2" className="m-b-half" justifyContent="space-between">
                <Text subdued size="small">
                    Lifetime Revenue
                </Text>
                <Text size="small">
                    <b>{formatCurrency(data.lifetime_revenue)}</b>
                </Text>
            </Flex>

            <Flex gap="2" className="m-b-half" justifyContent="space-between">
                <Text subdued size="small">
                    Balance Due
                </Text>
                <Text size="small">
                    <b>{formatCurrency(data.balance_due)}</b>
                </Text>
            </Flex>

            <Flex gap="2" className="m-b-half" justifyContent="space-between">
                <Text subdued size="small">
                    Total Locations
                </Text>
                <Text size="small">
                    <b>{data.total_locations}</b>
                </Text>
            </Flex>

            <Flex gap="2" className="m-b-half" justifyContent="space-between">
                <Text subdued size="small">
                    Active Memberships
                </Text>
                <Text size="small">
                    <b>{data.active_memberships}</b>
                </Text>
            </Flex>

            <Flex gap="2" className="m-b-half" justifyContent="space-between">
                <Text subdued size="small">
                    Active Service Agreements
                </Text>
                <Text size="small">
                    <b>{data.active_service_agreements}</b>
                </Text>
            </Flex>

            <Flex gap="2" justifyContent="space-between">
                <Text subdued size="small">
                    Open Estimates
                </Text>
                <Text size="small">
                    <b>{data.open_estimates}</b>
                </Text>
            </Flex>
        </MessageCard>
    );
};
